// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"310":"81815905550a8217","4450":"33ec94aab25b3351","6272":"aa4472f7082b94cd","7584":"d9652db206d50763","9671":"4c6cf4913daac62f"}[chunkId] + ".css";
};